import axios from "axios";
const URL = "https://commentsapireact.herokuapp.com/"
const getCommentsApi = async () => {
    const res = await axios.get(URL);
    return res.data;
}
const addCommentApi = async (email: string, commentInfo: string,parentId:number) => {
    const body = { email, commentInfo,parentId}
    const res = await axios.post(URL, body);
    return res.data;
}
const updateCommentApi = async (id: number, email: string, commentInfo: string) => {
    const body = { id,email, commentInfo }
    const res = await axios.put(URL, body)
    return res.data;
}
const removeCommentApi = async (id: string) => {
    const res = await axios.delete(URL, {
        data: { id },
    });
    return res.data;
}
export {getCommentsApi,addCommentApi,updateCommentApi,removeCommentApi};